import React from 'react';
import windowSize from 'react-window-size';
import { Link } from "react-router-dom";
import { ROUTES } from "./constants";
import firebase from 'firebase/app';
import "firebase/auth";

const styles = {
  sideBar: {
    minHeight: '100vh',
    backgroundColor: '#4d394b',
    width: '70px'
  },
  button: {
    cursor: 'pointer'
  },
  liItem: {
    backgroundColor: '#4d394b'
  }
}

class ResponsiveSidebarView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      toggle: false
    }
  }

  componentWillMount() {
    this.unlistenAuth = firebase.auth().onAuthStateChanged(user => this.setState({ user: user }));
  }
  componentWillUnmount() {
    this.unlistenAuth();
  }

  render() {

    let isMobile = this.props.windowWidth <= 720;
    let toggleClass = !this.state.toggle && isMobile ? '' : 'drawer-open';
    let user = this.state.user;
    return (
      <div className="col-md-3 col-lg-3 col-xl-3 pt-3 p-0 pl-1 text-white" style={styles.sideBar}
        onClick={() => this.setState({ toggle: !this.state.toggle })}>

        <header className={!isMobile ? `d-none` : undefined}>
          {
            isMobile
              ?
              <div className="col-auto pl-0" style={{ zIndex: 2 }} onClick={() => this.setState({ toggle: !this.state.toggle })}>
                <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
                </svg>
              </div>
              :
              undefined
          }
        </header>
        <div className={`${toggleClass}`}>
          <nav className={!isMobile ? `col` : undefined}>
            <h3 className={`my-3 ${isMobile ? `pl-5` : `pl-2`}`}>Slack Clone</h3>
            {
              user
                ?
                <div className="d-flex mt-3">
                  <div className="col pl-0 pr-0">
                    <p>Welcome</p>
                  </div>
                  <div className="col-auto">
                    <svg width="24" height="24" fill="#FFF" viewBox="0 0 24 24"
                      role="button"
                      style={styles.button}
                      onClick={this.props.handleSignOut}>
                      aria-label="sign out button"
                      xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 0h24v24H0z" fill="none" />
                      <path d="M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" />
                    </svg>
                  </div>
                </div>
                :
                undefined
            }
            <div>
            </div>
            <div className="dropdown-divider"></div>

            <h5 className="text-white">Channels</h5>
            <ul className="list-group">
              <li className={`list-group-item rounded-0 border-0 p-1 ${this.props.chanName === 'general' ? 'current' : undefined}`} style={styles.liItem}
                onClick={() => this.setState({ messageChannel: 'general', isActive: !this.props.isActive, inactive: !this.props.inactive })}>
                {
                  this.props.chanName !== "general" ?

                    <Link to={ROUTES.generalChannel}># general</Link> :
                    "# general"
                }
              </li>
              <li className={`list-group-item rounded-0 border-0 p-1 ${this.props.chanName === 'random' ? 'current' : undefined}`} style={styles.liItem}
                onClick={() => this.setState({ messageChannel: 'random', isActive: !this.props.isActive, inactive: !this.props.inactive })}>
                <Link to={ROUTES.randomChannel}># random</Link></li>
            </ul>
          </nav>
        </div>
      </div>
    );
  }
}
export default windowSize(ResponsiveSidebarView);


// WEBPACK FOOTER //
// ./src/Responsive.js